var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.text))]),_c('button',{on:{"click":function($event){_vm.text = '我是新的一'}}},[_vm._v("监听")])])
}
var staticRenderFns = []

export { render, staticRenderFns }